import { useQuery } from '@tanstack/react-query';

import { shiftConfirmationsApi } from '@/lib/api/shift-confirmations.api';

import type { ShiftConfirmationQuery } from '@repo/shared-types';

export function useShiftConfirmations(query?: Partial<ShiftConfirmationQuery>) {
  return useQuery({
    queryKey: ['shift-confirmations', query],
    queryFn: () => shiftConfirmationsApi.getShiftConfirmations(query),
  });
}
